export const message = {
  info: {
    proceedConfirmBoxMessage:
      "This action cannot be undone. Do you want to proceed?",
    generalConfirmBoxMessage: "Do you want to proceed?",
    acceptanceStatusComment:
      "Enter the reason or remarks for the action performed",
    productDeleteConfirmMessage:
      "This will delete whole product. Do you confirm to delete whole product?",
    copiedSuccessfully: "Copied successfully",
    noRecordsModified: "No records modified",
  },
  success: {
    generalSuccessUpdateMessage: "Successfully updated",
    userAddedSuccessfully: "User added successfully!",
    updatedSuccessfully: "Data updated successfully",
    deletedSuccessfully: "Data deleted successfully",
    addedSuccessfully: "Data added successfully",
    generalSuccessFetchMessage: "Records fetched successfully",
  },
  error: {
    generalFailure: "Something went wrong",
    confirmPasswordMismatch: "Password and Confirm Password does not match!",
    somethingWentWrong: "Something went wrong contact Admin!",
    oldPasswordMissMatch: "Old password does not match",
    userDetails: "Error while fetching user details",
    companyDetails: "Error while fetching company details",
    userRoles: "Error while fetching user roles",
    noRecords: "No records Found",
    noProductSelected: "Please select product(s) first!",
    actionNotAllowed: "This action is not allowed",
  },
};
